import axios from 'axios';

const baseUrl = process.env.VUE_APP_API_PATH ? process.env.VUE_APP_API_PATH : '/';

const axiosInstance = axios.create({
  baseURL: `${baseUrl}actions`
});

export default axiosInstance;
